/* Sizing reference and body plausibility rules copied from beito-fit-finder.liquid.
   Regenerate this file with build-plausibility.py when those rules change. */
(() => {
  const BODY_MORPHOLOGY = {
    /*
      Rasse ist nur ein Form-Prior. Die Faktoren sind absichtlich moderat,
      weil Gewicht und individuelle Messwerte wesentlich aussagekräftiger sind.
    */
    /*
      back = moderater Längenfaktor für die Strecke Schulterblätter -> Rutenansatz.
      Grundlage ist nicht eine erfundene harte Rassetabelle, sondern die in
      morphometrischen Studien belegte Kombination aus Gesamtkörpergrösse und
      rassetypischer Längen-/Breitenform. Extreme Langkörper-Typen werden separat
      behandelt; alle anderen Faktoren bleiben absichtlich nahe 1.0.
    */
    average:       { neck: 1.00, chest: 1.00, back: 1.00 },
    sighthound:    { neck: 0.96, chest: 1.03, back: 1.02 },
    stocky:        { neck: 1.05, chest: 1.04, back: 0.94 },
    deep_chest:    { neck: 0.98, chest: 1.04, back: 1.01 },
    northern:      { neck: 1.01, chest: 1.01, back: 0.98 },
    retriever:     { neck: 1.02, chest: 1.03, back: 0.98 },
    shepherd:      { neck: 0.99, chest: 1.00, back: 1.00 },
    mountain:      { neck: 1.03, chest: 1.04, back: 0.96 },
    terrier:       { neck: 1.00, chest: 1.00, back: 0.98 },
    small_compact: { neck: 1.02, chest: 1.02, back: 0.96 },
    long_body:     { neck: 0.99, chest: 1.05, back: 1.12 },
    poodle_slim:   { neck: 0.97, chest: 0.99, back: 1.02 },
    sport_slim:    { neck: 0.97, chest: 1.00, back: 1.03 },
    giant_slim:    { neck: 0.99, chest: 1.05, back: 1.03 }
  };

  const BREED_MORPHOLOGY = {
    "Affenpinscher": "small_compact",
    "Afghanischer Windhund": "sighthound",
    "Airedale Terrier": "terrier",
    "Akita": "northern",
    "Alaskan Husky": "northern",
    "Alaskan Malamute": "northern",
    "American Staffordshire Terrier": "stocky",
    "Appenzeller Sennenhund": "shepherd",
    "Australian Cattle Dog": "shepherd",
    "Australian Kelpie": "shepherd",
    "Australian Shepherd": "shepherd",
    "Azawakh": "sighthound",
    "Basenji": "sport_slim",
    "Beagle": "average",
    "Bearded Collie": "shepherd",
    "Belgischer Schäferhund – Groenendael": "shepherd",
    "Belgischer Schäferhund – Malinois": "shepherd",
    "Belgischer Schäferhund – Tervueren": "shepherd",
    "Berner Sennenhund": "mountain",
    "Border Collie": "shepherd",
    "Boston Terrier": "stocky",
    "Boxer": "stocky",
    "Briard": "shepherd",
    "Bull Terrier": "stocky",
    "Bulldog": "stocky",
    "Bullmastiff": "stocky",
    "Cairn Terrier": "terrier",
    "Cane Corso": "stocky",
    "Cavalier King Charles Spaniel": "small_compact",
    "Chihuahua": "small_compact",
    "Chow Chow": "northern",
    "Cocker Spaniel": "average",
    "Collie Kurzhaar": "shepherd",
    "Collie Langhaar": "shepherd",
    "Dackel": "long_body",
    "Dalmatiner": "deep_chest",
    "Deutsche Dogge": "giant_slim",
    "Deutscher Pinscher": "terrier",
    "Deutscher Schäferhund": "shepherd",
    "Deutsch Drahthaar": "deep_chest",
    "Deutsch Kurzhaar": "deep_chest",
    "Dobermann": "deep_chest",
    "English Setter": "deep_chest",
    "English Springer Spaniel": "average",
    "Entlebucher Sennenhund": "shepherd",
    "Epagneul Breton": "average",
    "Eurasier": "northern",
    "Eurohound": "sport_slim",
    "Flat-Coated Retriever": "retriever",
    "Fox Terrier": "terrier",
    "Französische Bulldogge": "stocky",
    "Galgo Español": "sighthound",
    "Golden Retriever": "retriever",
    "Gordon Setter": "deep_chest",
    "Greyhound": "sighthound",
    "Greyster": "sport_slim",
    "Grosser Schweizer Sennenhund": "mountain",
    "Havaneser": "small_compact",
    "Holländischer Schäferhund": "shepherd",
    "Hovawart": "shepherd",
    "Irish Setter": "deep_chest",
    "Irish Terrier": "terrier",
    "Irish Wolfhound": "sighthound",
    "Italienisches Windspiel": "sighthound",
    "Jack Russell Terrier": "terrier",
    "Labrador Retriever": "retriever",
    "Lagotto Romagnolo": "average",
    "Leonberger": "mountain",
    "Magyar Vizsla": "deep_chest",
    "Malteser": "small_compact",
    "Mastiff": "stocky",
    "Miniature American Shepherd": "shepherd",
    "Mittelschnauzer": "terrier",
    "Mops": "stocky",
    "Neufundländer": "mountain",
    "Nova Scotia Duck Tolling Retriever": "retriever",
    "Olde English Bulldogge": "stocky",
    "Papillon": "small_compact",
    "Parson Russell Terrier": "terrier",
    "Podenco": "sighthound",
    "Pointer": "deep_chest",
    "Pomeranian / Zwergspitz": "small_compact",
    "Pudel Gross": "poodle_slim",
    "Pudel Klein": "poodle_slim",
    "Rhodesian Ridgeback": "deep_chest",
    "Riesenschnauzer": "terrier",
    "Rottweiler": "stocky",
    "Saluki": "sighthound",
    "Samojede": "northern",
    "Shetland Sheepdog": "shepherd",
    "Shiba Inu": "northern",
    "Siberian Husky": "northern",
    "Silken Windsprite": "sighthound",
    "Sloughi": "sighthound",
    "Staffordshire Bull Terrier": "stocky",
    "Weimaraner": "deep_chest",
    "West Highland White Terrier": "terrier",
    "Whippet": "sighthound",
    "Yorkshire Terrier": "terrier",
    "Mischling / andere Rasse": "average",
  };

  const BREED_WEIGHT_REFERENCE = {
    "Boxer": { minKg: 22.7, maxKg: 36.3, source: "American Boxer Club" },
    "Fox Terrier": { minKg: 6.8, maxKg: 8.2, source: "AKC" },
    "French Bulldog": { minKg: 8.0, maxKg: 14.0, source: "FCI" },
    "Maltese": { minKg: 3.0, maxKg: 4.0, source: "FCI" },
    "Olde English Bulldogge": { minKg: 22.7, maxKg: 36.3, source: "UKC" },

    "Affenpinscher": { minKg: 3.2, maxKg: 4.5, source: "AKC" },
    "Afghan Hound": { minKg: 22.7, maxKg: 27.2, source: "AKC" },
    "Airedale Terrier": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Akita": { minKg: 31.8, maxKg: 59.0, source: "AKC" },
    "Alaskan Husky": { minKg: 20.0, maxKg: 30.0, source: "SNL" },
    "Alaskan Klee Kai": { minKg: 2.7, maxKg: 11.3, source: "AKC" },
    "Alaskan Malamute": { minKg: 34.0, maxKg: 38.6, source: "AKC" },
    "American English Coonhound": { minKg: 20.4, maxKg: 29.5, source: "AKC" },
    "American Eskimo Dog": { minKg: 2.7, maxKg: 15.9, source: "AKC" },
    "American Foxhound": { minKg: 27.2, maxKg: 31.8, source: "AKC" },
    "American Hairless Terrier": { minKg: 5.4, maxKg: 12.7, source: "AKC" },
    "American Leopard Hound": { minKg: 15.9, maxKg: 34.0, source: "AKC" },
    "American Staffordshire Terrier": { minKg: 18.1, maxKg: 31.8, source: "AKC" },
    "American Water Spaniel": { minKg: 11.3, maxKg: 20.4, source: "AKC" },
    "Anatolian Shepherd Dog": { minKg: 36.3, maxKg: 68.0, source: "AKC" },
    "Appenzeller Sennenhund": { minKg: 21.8, maxKg: 31.8, source: "AKC" },
    "Australian Cattle Dog": { minKg: 15.9, maxKg: 22.7, source: "AKC" },
    "Australian Kelpie": { minKg: 15.9, maxKg: 22.7, source: "AKC" },
    "Australian Shepherd": { minKg: 18.1, maxKg: 29.5, source: "AKC" },
    "Australian Stumpy Tail Cattle Dog": { minKg: 14.5, maxKg: 20.4, source: "AKC" },
    "Australian Terrier": { minKg: 6.8, maxKg: 9.1, source: "AKC" },
    "Azawakh": { minKg: 15.0, maxKg: 24.9, source: "AKC" },
    "Barbado da Terceira": { minKg: 20.9, maxKg: 27.2, source: "AKC" },
    "Barbet": { minKg: 15.9, maxKg: 29.5, source: "AKC" },
    "Basenji": { minKg: 10.0, maxKg: 10.9, source: "AKC" },
    "Basset Fauve de Bretagne": { minKg: 10.4, maxKg: 17.7, source: "AKC" },
    "Basset Hound": { minKg: 18.1, maxKg: 29.5, source: "AKC" },
    "Bavarian Mountain Scent Hound": { minKg: 16.8, maxKg: 29.9, source: "AKC" },
    "Bearded Collie": { minKg: 20.4, maxKg: 24.9, source: "AKC" },
    "Beauceron": { minKg: 31.8, maxKg: 49.9, source: "AKC" },
    "Bedlington Terrier": { minKg: 7.7, maxKg: 10.4, source: "AKC" },
    "Belgian Laekenois": { minKg: 24.9, maxKg: 29.5, source: "AKC" },
    "Belgian Malinois": { minKg: 18.1, maxKg: 36.3, source: "AKC" },
    "Belgian Sheepdog": { minKg: 20.4, maxKg: 34.0, source: "AKC" },
    "Belgian Tervuren": { minKg: 20.4, maxKg: 34.0, source: "AKC" },
    "Bergamasco Sheepdog": { minKg: 25.9, maxKg: 38.1, source: "AKC" },
    "Berger Picard": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Bernese Mountain Dog": { minKg: 31.8, maxKg: 52.2, source: "AKC" },
    "Bichon Frise": { minKg: 5.4, maxKg: 8.2, source: "AKC" },
    "Biewer Terrier": { minKg: 1.8, maxKg: 3.6, source: "AKC" },
    "Black Russian Terrier": { minKg: 36.3, maxKg: 59.0, source: "AKC" },
    "Black and Tan Coonhound": { minKg: 29.5, maxKg: 49.9, source: "AKC" },
    "Bloodhound": { minKg: 36.3, maxKg: 49.9, source: "AKC" },
    "Blue Picardy Spaniel": { minKg: 20.4, maxKg: 24.9, source: "AKC" },
    "Bluetick Coonhound": { minKg: 20.4, maxKg: 36.3, source: "AKC" },
    "Boerboel": { minKg: 68.0, maxKg: 90.7, source: "AKC" },
    "Bohemian Shepherd": { minKg: 16.8, maxKg: 27.2, source: "AKC" },
    "Bolognese": { minKg: 2.7, maxKg: 4.5, source: "AKC" },
    "Border Collie": { minKg: 13.6, maxKg: 24.9, source: "AKC" },
    "Border Terrier": { minKg: 5.2, maxKg: 7.0, source: "AKC" },
    "Borzoi": { minKg: 27.2, maxKg: 47.6, source: "AKC" },
    "Boston Terrier": { minKg: 5.4, maxKg: 11.3, source: "AKC" },
    "Bouvier des Ardennes": { minKg: 22.0, maxKg: 35.2, source: "AKC" },
    "Bouvier des Flandres": { minKg: 31.8, maxKg: 49.9, source: "AKC" },
    "Boykin Spaniel": { minKg: 11.3, maxKg: 18.1, source: "AKC" },
    "Bracco Italiano": { minKg: 24.9, maxKg: 40.8, source: "AKC" },
    "Braque Francais Pyrenean": { minKg: 18.1, maxKg: 24.9, source: "AKC" },
    "Braque Saint-Germain": { minKg: 18.1, maxKg: 26.3, source: "AKC" },
    "Braque du Bourbonnais": { minKg: 15.9, maxKg: 24.0, source: "AKC" },
    "Briard": { minKg: 24.9, maxKg: 45.4, source: "AKC" },
    "Brittany": { minKg: 13.6, maxKg: 18.1, source: "AKC" },
    "Broholmer": { minKg: 40.8, maxKg: 68.0, source: "AKC" },
    "Brussels Griffon": { minKg: 3.6, maxKg: 4.5, source: "AKC" },
    "Bull Terrier": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Bulldog": { minKg: 18.1, maxKg: 22.7, source: "AKC" },
    "Bullmastiff": { minKg: 45.4, maxKg: 59.0, source: "AKC" },
    "Cairn Terrier": { minKg: 5.9, maxKg: 6.4, source: "AKC" },
    "Calupoh": { minKg: 31.8, maxKg: 45.4, source: "AKC" },
    "Canaan Dog": { minKg: 15.9, maxKg: 24.9, source: "AKC" },
    "Canadian Eskimo Dog": { minKg: 18.1, maxKg: 39.9, source: "AKC" },
    "Cane Corso": { minKg: 40.0, maxKg: 50.0, source: "FCI" },
    "Cardigan Welsh Corgi": { minKg: 11.3, maxKg: 17.2, source: "AKC" },
    "Carolina Dog": { minKg: 13.6, maxKg: 24.9, source: "AKC" },
    "Catahoula Leopard Dog": { minKg: 22.7, maxKg: 43.1, source: "AKC" },
    "Caucasian Shepherd Dog": { minKg: 44.9, maxKg: 77.1, source: "AKC" },
    "Cavalier King Charles Spaniel": { minKg: 5.9, maxKg: 8.2, source: "AKC" },
    "Central Asian Shepherd Dog": { minKg: 39.9, maxKg: 49.9, source: "AKC" },
    "Cesky Terrier": { minKg: 6.4, maxKg: 10.9, source: "AKC" },
    "Chesapeake Bay Retriever": { minKg: 24.9, maxKg: 36.3, source: "AKC" },
    "Chihuahua": { minKg: 0.5, maxKg: 2.7, source: "AKC; Höchstgewicht laut Rassestandard, Untergrenze ist Eingabeminimum" },
    "Chinese Crested": { minKg: 3.6, maxKg: 5.4, source: "AKC" },
    "Chinese Shar-Pei": { minKg: 20.4, maxKg: 27.2, source: "AKC" },
    "Chinook": { minKg: 22.7, maxKg: 40.8, source: "AKC" },
    "Chow Chow": { minKg: 20.4, maxKg: 31.8, source: "AKC" },
    "Cirneco dell'Etna": { minKg: 8.6, maxKg: 12.7, source: "AKC" },
    "Clumber Spaniel": { minKg: 24.9, maxKg: 38.6, source: "AKC" },
    "Cocker Spaniel": { minKg: 9.1, maxKg: 13.6, source: "AKC" },
    "Collie": { minKg: 22.7, maxKg: 34.0, source: "AKC" },
    "Coton de Tulear": { minKg: 3.6, maxKg: 6.8, source: "AKC" },
    "Croatian Sheepdog": { minKg: 13.2, maxKg: 20.0, source: "AKC" },
    "Curly-Coated Retriever": { minKg: 27.2, maxKg: 43.1, source: "AKC" },
    "Dachshund": { minKg: 5.0, maxKg: 14.5, source: "AKC" },
    "Dalmatian": { minKg: 20.4, maxKg: 31.8, source: "AKC" },
    "Dandie Dinmont Terrier": { minKg: 8.2, maxKg: 10.9, source: "AKC" },
    "Danish-Swedish Farmdog": { minKg: 6.8, maxKg: 9.1, source: "AKC" },
    "Deutscher Wachtelhund": { minKg: 18.1, maxKg: 24.9, source: "AKC" },
    "Doberman Pinscher": { minKg: 27.2, maxKg: 45.4, source: "AKC" },
    "Dogo Argentino": { minKg: 36.3, maxKg: 45.4, source: "AKC" },
    "Dogue de Bordeaux": { minKg: 44.9, maxKg: 49.9, source: "AKC" },
    "Drentsche Patrijshond": { minKg: 24.9, maxKg: 33.1, source: "AKC" },
    "Drever": { minKg: 15.9, maxKg: 18.1, source: "AKC" },
    "Dutch Shepherd": { minKg: 19.1, maxKg: 34.0, source: "AKC" },
    "English Cocker Spaniel": { minKg: 11.8, maxKg: 15.4, source: "AKC" },
    "English Foxhound": { minKg: 27.2, maxKg: 34.0, source: "AKC" },
    "English Setter": { minKg: 20.4, maxKg: 36.3, source: "AKC" },
    "English Springer Spaniel": { minKg: 18.1, maxKg: 22.7, source: "AKC" },
    "English Toy Spaniel": { minKg: 3.6, maxKg: 6.4, source: "AKC" },
    "Entlebucher Mountain Dog": { minKg: 18.1, maxKg: 29.5, source: "AKC" },
    "Estrela Mountain Dog": { minKg: 34.9, maxKg: 59.9, source: "AKC" },
    "Eurasier": { minKg: 18.1, maxKg: 31.8, source: "AKC" },
    "Eurohound": { minKg: 18.0, maxKg: 34.0, source: "performance_reference" },
    "Field Spaniel": { minKg: 15.9, maxKg: 22.7, source: "AKC" },
    "Finnish Lapphund": { minKg: 15.0, maxKg: 24.0, source: "AKC" },
    "Finnish Spitz": { minKg: 9.1, maxKg: 15.0, source: "AKC" },
    "Flat-Coated Retriever": { minKg: 27.2, maxKg: 31.8, source: "AKC" },
    "French Spaniel": { minKg: 22.7, maxKg: 27.2, source: "AKC" },
    "Galgo Español": { minKg: 20.0, maxKg: 30.0, source: "FCI_secondary" },
    "German Longhaired Pointer": { minKg: 24.9, maxKg: 36.3, source: "AKC" },
    "German Pinscher": { minKg: 11.3, maxKg: 20.4, source: "AKC" },
    "German Shepherd Dog": { minKg: 22.7, maxKg: 40.8, source: "AKC" },
    "German Shorthaired Pointer": { minKg: 20.4, maxKg: 31.8, source: "AKC" },
    "German Spitz": { minKg: 10.9, maxKg: 11.8, source: "AKC" },
    "German Wirehaired Pointer": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Giant Schnauzer": { minKg: 24.9, maxKg: 43.1, source: "AKC" },
    "Glen of Imaal Terrier": { minKg: 14.5, maxKg: 18.1, source: "AKC" },
    "Golden Retriever": { minKg: 24.9, maxKg: 34.0, source: "AKC" },
    "Gordon Setter": { minKg: 20.4, maxKg: 36.3, source: "AKC" },
    "Grand Basset Griffon Vendéen": { minKg: 18.1, maxKg: 20.4, source: "AKC" },
    "Great Dane": { minKg: 49.9, maxKg: 79.4, source: "AKC" },
    "Great Pyrenees": { minKg: 38.6, maxKg: 45.4, source: "AKC" },
    "Greater Swiss Mountain Dog": { minKg: 38.6, maxKg: 63.5, source: "AKC" },
    "Greyhound": { minKg: 27.2, maxKg: 31.8, source: "AKC" },
    "Greyster": { minKg: 16.0, maxKg: 35.0, source: "performance_reference" },
    "Hamiltonstovare": { minKg: 18.1, maxKg: 34.0, source: "AKC" },
    "Hanoverian Scenthound": { minKg: 35.8, maxKg: 44.9, source: "AKC" },
    "Harrier": { minKg: 20.4, maxKg: 27.2, source: "AKC" },
    "Havanese": { minKg: 3.2, maxKg: 5.9, source: "AKC" },
    "Hokkaido": { minKg: 20.0, maxKg: 29.9, source: "AKC" },
    "Hovawart": { minKg: 29.5, maxKg: 40.8, source: "AKC" },
    "Ibizan Hound": { minKg: 20.4, maxKg: 22.7, source: "AKC" },
    "Icelandic Sheepdog": { minKg: 11.3, maxKg: 13.6, source: "AKC" },
    "Irish Red and White Setter": { minKg: 15.9, maxKg: 27.2, source: "AKC" },
    "Irish Setter": { minKg: 27.2, maxKg: 31.8, source: "AKC" },
    "Irish Terrier": { minKg: 11.3, maxKg: 12.2, source: "AKC" },
    "Irish Water Spaniel": { minKg: 20.4, maxKg: 30.8, source: "AKC" },
    "Irish Wolfhound": { minKg: 47.6, maxKg: 54.4, source: "AKC" },
    "Italian Greyhound": { minKg: 3.2, maxKg: 6.4, source: "AKC" },
    "Jagdterrier": { minKg: 7.7, maxKg: 10.0, source: "AKC" },
    "Japanese Akitainu": { minKg: 24.9, maxKg: 34.0, source: "AKC" },
    "Japanese Chin": { minKg: 3.2, maxKg: 5.0, source: "AKC" },
    "Japanese Spitz": { minKg: 4.5, maxKg: 11.3, source: "AKC" },
    "Japanese Terrier": { minKg: 4.5, maxKg: 5.4, source: "AKC" },
    "Kai Ken": { minKg: 11.3, maxKg: 18.1, source: "AKC" },
    "Karelian Bear Dog": { minKg: 20.0, maxKg: 22.2, source: "AKC" },
    "Keeshond": { minKg: 15.9, maxKg: 20.4, source: "AKC" },
    "Kerry Blue Terrier": { minKg: 15.0, maxKg: 18.1, source: "AKC" },
    "Kishu Ken": { minKg: 13.6, maxKg: 27.2, source: "AKC" },
    "Komondor": { minKg: 36.3, maxKg: 45.4, source: "AKC" },
    "Korean Jindo Dog": { minKg: 13.6, maxKg: 22.7, source: "AKC" },
    "Kromfohrlander": { minKg: 9.1, maxKg: 15.9, source: "AKC" },
    "Kuvasz": { minKg: 31.8, maxKg: 52.2, source: "AKC" },
    "Labrador Retriever": { minKg: 24.9, maxKg: 36.3, source: "AKC" },
    "Lagotto Romagnolo": { minKg: 10.9, maxKg: 15.9, source: "AKC" },
    "Lancashire Heeler": { minKg: 4.1, maxKg: 7.7, source: "AKC" },
    "Large Munsterlander": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Leonberger": { minKg: 40.8, maxKg: 77.1, source: "AKC" },
    "Lhasa Apso": { minKg: 5.4, maxKg: 8.2, source: "AKC" },
    "Lucas Terrier": { minKg: 5.4, maxKg: 8.6, source: "AKC" },
    "Manchester Terrier (Standard)": { minKg: 5.4, maxKg: 10.0, source: "AKC" },
    "Mastiff": { minKg: 54.4, maxKg: 104.3, source: "AKC" },
    "Miniature American Shepherd": { minKg: 9.1, maxKg: 18.1, source: "AKC" },
    "Miniature Bull Terrier": { minKg: 8.2, maxKg: 12.7, source: "AKC" },
    "Miniature Pinscher": { minKg: 3.6, maxKg: 4.5, source: "AKC" },
    "Miniature Schnauzer": { minKg: 5.0, maxKg: 9.1, source: "AKC" },
    "Mountain Cur": { minKg: 13.6, maxKg: 27.2, source: "AKC" },
    "Mudi": { minKg: 8.2, maxKg: 13.2, source: "AKC" },
    "Neapolitan Mastiff": { minKg: 49.9, maxKg: 68.0, source: "AKC" },
    "Nederlandse Kooikerhondje": { minKg: 9.1, maxKg: 13.6, source: "AKC" },
    "Newfoundland": { minKg: 45.4, maxKg: 68.0, source: "AKC" },
    "Norfolk Terrier": { minKg: 5.0, maxKg: 5.4, source: "AKC" },
    "Norrbottenspets": { minKg: 9.1, maxKg: 13.6, source: "AKC" },
    "Norwegian Buhund": { minKg: 11.8, maxKg: 18.1, source: "AKC" },
    "Norwegian Elkhound": { minKg: 21.8, maxKg: 24.9, source: "AKC" },
    "Norwegian Lundehund": { minKg: 5.4, maxKg: 8.2, source: "AKC" },
    "Nova Scotia Duck Tolling Retriever": { minKg: 15.9, maxKg: 22.7, source: "AKC" },
    "Old Danish Pointer": { minKg: 25.9, maxKg: 34.9, source: "AKC" },
    "Old English Sheepdog": { minKg: 27.2, maxKg: 45.4, source: "AKC" },
    "Otterhound": { minKg: 36.3, maxKg: 52.2, source: "AKC" },
    "Papillon": { minKg: 2.3, maxKg: 4.5, source: "AKC" },
    "Parson Russell Terrier": { minKg: 5.9, maxKg: 7.7, source: "AKC" },
    "Pembroke Welsh Corgi": { minKg: 10.9, maxKg: 13.6, source: "AKC" },
    "Perro de Presa Canario": { minKg: 38.1, maxKg: 49.9, source: "AKC" },
    "Petit Basset Griffon Vendéen": { minKg: 11.3, maxKg: 18.1, source: "AKC" },
    "Pharaoh Hound": { minKg: 20.4, maxKg: 24.9, source: "AKC" },
    "Plott": { minKg: 18.1, maxKg: 27.2, source: "AKC" },
    "Pointer": { minKg: 20.4, maxKg: 34.0, source: "AKC" },
    "Polish Lowland Sheepdog": { minKg: 13.6, maxKg: 22.7, source: "AKC" },
    "Pomeranian": { minKg: 1.4, maxKg: 3.2, source: "AKC" },
    "Pont-Audemer Spaniel": { minKg: 15.0, maxKg: 21.8, source: "AKC" },
    "Poodle (Miniature)": { minKg: 4.5, maxKg: 6.8, source: "AKC" },
    "Poodle (Standard)": { minKg: 18.1, maxKg: 31.8, source: "AKC" },
    "Poodle (Toy)": { minKg: 1.8, maxKg: 2.7, source: "AKC" },
    "Porcelaine": { minKg: 24.9, maxKg: 28.1, source: "AKC" },
    "Portuguese Podengo Pequeno": { minKg: 4.1, maxKg: 5.9, source: "AKC" },
    "Portuguese Pointer": { minKg: 15.9, maxKg: 26.8, source: "AKC" },
    "Portuguese Sheepdog": { minKg: 17.0, maxKg: 26.8, source: "AKC" },
    "Portuguese Water Dog": { minKg: 15.9, maxKg: 27.2, source: "AKC" },
    "Pudelpointer": { minKg: 20.4, maxKg: 31.8, source: "AKC" },
    "Pug": { minKg: 6.4, maxKg: 8.2, source: "AKC" },
    "Puli": { minKg: 11.3, maxKg: 15.9, source: "AKC" },
    "Pumi": { minKg: 10.0, maxKg: 13.2, source: "AKC" },
    "Pyrenean Mastiff": { minKg: 54.4, maxKg: 86.2, source: "AKC" },
    "Pyrenean Shepherd": { minKg: 6.8, maxKg: 13.6, source: "AKC" },
    "Rafeiro do Alentejo": { minKg: 34.9, maxKg: 59.9, source: "AKC" },
    "Rat Terrier": { minKg: 4.5, maxKg: 11.3, source: "AKC" },
    "Redbone Coonhound": { minKg: 20.4, maxKg: 31.8, source: "AKC" },
    "Rhodesian Ridgeback": { minKg: 31.8, maxKg: 38.6, source: "AKC" },
    "Romanian Carpathian Shepherd": { minKg: 31.8, maxKg: 45.4, source: "AKC" },
    "Romanian Mioritic Shepherd Dog": { minKg: 45.4, maxKg: 59.0, source: "AKC" },
    "Rottweiler": { minKg: 36.3, maxKg: 61.2, source: "AKC" },
    "Russell Terrier": { minKg: 4.1, maxKg: 6.8, source: "AKC" },
    "Russian Tsvetnaya Bolonka": { minKg: 2.7, maxKg: 4.1, source: "AKC" },
    "Saarloos Wolfhond": { minKg: 27.2, maxKg: 43.1, source: "AKC" },
    "Saint Bernard": { minKg: 54.4, maxKg: 81.6, source: "AKC" },
    "Saluki": { minKg: 18.1, maxKg: 29.5, source: "AKC" },
    "Samoyed": { minKg: 15.9, maxKg: 29.5, source: "AKC" },
    "Schapendoes": { minKg: 11.8, maxKg: 24.9, source: "AKC" },
    "Schipperke": { minKg: 4.5, maxKg: 7.3, source: "AKC" },
    "Scottish Deerhound": { minKg: 34.0, maxKg: 49.9, source: "AKC" },
    "Scottish Terrier": { minKg: 8.2, maxKg: 10.0, source: "AKC" },
    "Sealyham Terrier": { minKg: 10.4, maxKg: 10.9, source: "AKC" },
    "Segugio Italiano": { minKg: 17.7, maxKg: 28.1, source: "AKC" },
    "Shetland Sheepdog": { minKg: 6.8, maxKg: 11.3, source: "AKC" },
    "Shiba Inu": { minKg: 7.7, maxKg: 10.4, source: "AKC" },
    "Shih Tzu": { minKg: 4.1, maxKg: 7.3, source: "AKC" },
    "Shikoku": { minKg: 15.9, maxKg: 24.9, source: "AKC" },
    "Siberian Husky": { minKg: 15.9, maxKg: 27.2, source: "AKC" },
    "Silken Windhound": { minKg: 10.0, maxKg: 20.4, source: "AKC" },
    "Skye Terrier": { minKg: 15.9, maxKg: 20.4, source: "AKC" },
    "Sloughi": { minKg: 20.4, maxKg: 29.5, source: "AKC" },
    "Slovakian Wirehaired Pointer": { minKg: 22.7, maxKg: 29.5, source: "AKC" },
    "Slovensky Cuvac": { minKg: 30.8, maxKg: 44.0, source: "AKC" },
    "Slovensky Kopov": { minKg: 15.0, maxKg: 20.0, source: "AKC" },
    "Small Munsterlander": { minKg: 18.1, maxKg: 27.2, source: "AKC" },
    "Smooth Fox Terrier": { minKg: 6.8, maxKg: 8.2, source: "AKC" },
    "Soft Coated Wheaten Terrier": { minKg: 13.6, maxKg: 18.1, source: "AKC" },
    "Spanish Mastiff": { minKg: 63.5, maxKg: 90.7, source: "AKC" },
    "Spanish Water Dog": { minKg: 14.1, maxKg: 22.2, source: "AKC" },
    "Stabyhoun": { minKg: 18.1, maxKg: 27.2, source: "AKC" },
    "Staffordshire Bull Terrier": { minKg: 10.9, maxKg: 17.2, source: "AKC" },
    "Standard Schnauzer": { minKg: 13.6, maxKg: 22.7, source: "AKC" },
    "Sussex Spaniel": { minKg: 15.9, maxKg: 20.4, source: "AKC" },
    "Swedish Lapphund": { minKg: 13.6, maxKg: 20.4, source: "AKC" },
    "Swedish Vallhund": { minKg: 9.1, maxKg: 15.9, source: "AKC" },
    "Taiwan Dog": { minKg: 11.8, maxKg: 18.1, source: "AKC" },
    "Teddy Roosevelt Terrier": { minKg: 3.6, maxKg: 11.3, source: "AKC" },
    "Thai Bangkaew": { minKg: 15.9, maxKg: 19.5, source: "AKC" },
    "Thai Ridgeback": { minKg: 15.9, maxKg: 34.0, source: "AKC" },
    "Tibetan Mastiff": { minKg: 31.8, maxKg: 68.0, source: "AKC" },
    "Tibetan Spaniel": { minKg: 4.1, maxKg: 6.8, source: "AKC" },
    "Tibetan Terrier": { minKg: 8.2, maxKg: 13.6, source: "AKC" },
    "Tornjak": { minKg: 28.1, maxKg: 49.9, source: "AKC" },
    "Tosa": { minKg: 45.4, maxKg: 90.7, source: "AKC" },
    "Toy Fox Terrier": { minKg: 1.8, maxKg: 4.1, source: "AKC" },
    "Treeing Tennessee Brindle": { minKg: 13.6, maxKg: 22.7, source: "AKC" },
    "Treeing Walker Coonhound": { minKg: 22.7, maxKg: 31.8, source: "AKC" },
    "Vizsla": { minKg: 20.0, maxKg: 27.2, source: "AKC" },
    "Volpino Italiano": { minKg: 3.6, maxKg: 7.3, source: "AKC" },
    "Weimaraner": { minKg: 24.9, maxKg: 40.8, source: "AKC" },
    "Welsh Springer Spaniel": { minKg: 15.9, maxKg: 24.9, source: "AKC" },
    "West Highland White Terrier": { minKg: 6.8, maxKg: 9.1, source: "AKC" },
    "Wetterhoun": { minKg: 22.7, maxKg: 34.0, source: "AKC" },
    "Whippet": { minKg: 11.3, maxKg: 18.1, source: "AKC" },
    "Wire Fox Terrier": { minKg: 6.8, maxKg: 8.2, source: "AKC" },
    "Wirehaired Pointing Griffon": { minKg: 15.9, maxKg: 31.8, source: "AKC" },
    "Wirehaired Vizsla": { minKg: 20.4, maxKg: 29.5, source: "AKC" },
    "Working Kelpie": { minKg: 12.7, maxKg: 27.2, source: "AKC" },
    "Xoloitzcuintli": { minKg: 4.5, maxKg: 24.9, source: "AKC" },
    "Yakutian Laika": { minKg: 18.1, maxKg: 24.9, source: "AKC" }
  };

  const BREED_ALIASES = {
    "Old English Bulldog": "Olde English Bulldogge",
    "Afghanischer Windhund": "Afghan Hound",
    "Belgischer Schäferhund – Groenendael": "Belgian Sheepdog",
    "Belgischer Schäferhund – Malinois": "Belgian Malinois",
    "Belgischer Schäferhund – Tervueren": "Belgian Tervuren",
    "Berner Sennenhund": "Bernese Mountain Dog",
    "Collie Kurzhaar": "Collie",
    "Collie Langhaar": "Collie",
    "Dackel": "Dachshund",
    "Dalmatiner": "Dalmatian",
    "Deutsch Drahthaar": "German Wirehaired Pointer",
    "Deutsch Kurzhaar": "German Shorthaired Pointer",
    "Deutsche Dogge": "Great Dane",
    "Deutscher Pinscher": "German Pinscher",
    "Deutscher Schäferhund": "German Shepherd Dog",
    "Dobermann": "Doberman Pinscher",
    "Entlebucher Sennenhund": "Entlebucher Mountain Dog",
    "Epagneul Breton": "Brittany",
    "Französische Bulldogge": "French Bulldog",
    "Grosser Schweizer Sennenhund": "Greater Swiss Mountain Dog",
    "Havaneser": "Havanese",
    "Holländischer Schäferhund": "Dutch Shepherd",
    "Italienisches Windspiel": "Italian Greyhound",
    "Jack Russell Terrier": "Russell Terrier",
    "Magyar Vizsla": "Vizsla",
    "Malteser": "Maltese",
    "Mittelschnauzer": "Standard Schnauzer",
    "Mops": "Pug",
    "Neufundländer": "Newfoundland",
    "Pomeranian / Zwergspitz": "Pomeranian",
    "Pudel Gross": "Poodle (Standard)",
    "Pudel Klein": "Poodle (Miniature)",
    "Riesenschnauzer": "Giant Schnauzer",
    "Samojede": "Samoyed"
  };

  const HYBRID_FIT = {
    /*
      HERSTELLERMASS BLEIBT DOMINANT.
      Bei einer bekannten Rasse mit plausiblem Erwachsenen-Gewicht dürfen
      Rasse + Gewicht zusammen maximal ca. 26% der Hybridwertung ausmachen.
      Davon entfällt der deutlich grössere Anteil auf das tatsächliche Gewicht,
      nicht auf die Rasseform.

      Liegt das eingegebene Gewicht weit ausserhalb des typischen Rassebereichs,
      wird der Rasse-Einfluss automatisch reduziert. Das schützt Welpen,
      Sporthunde und individuell sehr leichte/schwere Hunde.
    */
    bodyContextWeightKnownBreedMin: 0.16,
    bodyContextWeightKnownBreedMax: 0.26,
    bodyContextWeightUnknownBreed: 0.12,
    genericWeightShare: 0.78,
    breedShapeShare: 0.22,

    minimumDecisionMargin: 2.50,

    /*
      Konservative allometrische Startwerte:
      Umfang ~ Faktor * kg^(1/3).
      Sie dienen NUR als Plausibilitätsmodell und nicht als Grössentabelle.
    */
    neckExpectedFactor: 14.4,
    chestExpectedFactor: 24.0,
    backExpectedFactor: 18.6,
    neckUncertainty: 0.24,
    chestUncertainty: 0.22,
    backUncertainty: 0.20,

    /*
      Messfehler-Erkennung:
      Hals bekommt bewusst eine grössere Toleranz als Brust, weil die
      Messposition am konischen Hals stärker variieren kann.
      Die effektive Schwelle wird zusätzlich an die Zuverlässigkeit der
      Rasse-/Gewichtsreferenz angepasst.
    */
    extremeNeckConflictKnownBreedMin: 0.30,
    extremeNeckConflictKnownBreedMax: 0.39,
    extremeChestConflictKnownBreedMin: 0.26,
    extremeChestConflictKnownBreedMax: 0.35,
    extremeBackConflictKnownBreedMin: 0.28,
    extremeBackConflictKnownBreedMax: 0.38,
    extremeNeckConflictUnknownBreed: 0.44,
    extremeChestConflictUnknownBreed: 0.40,
    extremeBackConflictUnknownBreed: 0.45,
    minimumNeckConflictCm: 5,
    minimumChestConflictCm: 8,
    minimumBackConflictCm: 6,
    ratioConflictKnownBreedMin: 0.30,
    ratioConflictKnownBreedMax: 0.40,

    /*
      TABELLENLÜCKEN / KNAPPE WIDERSPRÜCHE
    */
    nearFitMeasurementWeight: 0.65,
    nearFitContextWeight: 0.35,
    nearFitNeckPct: 0.05,
    nearFitNeckMinCm: 1.0,
    nearFitNeckMaxCm: 2.5,
    nearFitChestPct: 0.05,
    nearFitChestMinCm: 2.0,
    nearFitChestMaxCm: 5.0,
    nearFitMinimumScore: 45
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCanonicalBreedName(breed) {
    const value = String(breed || '').trim();
    return BREED_ALIASES[value] || value;
  }

  function inferBreedMorphology(breed) {
    const n = normalize(breed);

    if (!n) return 'average';

    // Windhunde / sehr schmale Athleten
    if (/(greyhound|windhund|whippet|saluki|sloughi|azawakh|borzoi|barsoi|galgo|podenco|pharaoh hound|ibizan hound|deerhound|wolfhound|silken wind|windsprite|cirneco)/i.test(n)) {
      return 'sighthound';
    }

    // Funktionale Zughunde / Pointer-Crosses
    if (/(greyster|eurohound|europäischer schlittenhund|scandinavian hound)/i.test(n)) {
      return 'sport_slim';
    }

    // Langer Körper / kurze Beine
    if (/(dachshund|dackel|basset|drever|corgi|vallhund)/i.test(n)) {
      return 'long_body';
    }

    // Molosser / kompakte kräftige Typen
    if (/(bulldog|mastiff|bullmastiff|boerboel|cane corso|dogo argentino|dogue de bordeaux|presa canario|tosa|rottweiler|stafford|bull terrier|boxer|shar-pei|neapolitan)/i.test(n)) {
      return 'stocky';
    }

    // Vorstehhunde und andere tiefer/athletischer gebaute Jagdhunde
    if (/(pointer|kurzhaar|drahthaar|setter|vizsla|weimaraner|dalmat|doberman|ridgeback|bracco|spinone|pudelpointer|munsterlander|münsterländer|wachtelhund|braque)/i.test(n)) {
      return 'deep_chest';
    }

    // Nordische / Spitz-Typen
    if (/(husky|malamute|akita|samoyed|samojede|shiba|spitz|laika|jindo|chow|elkhound|buhund|hokkaido|kishu|kai ken|eurasier|keeshond|schipperke|norrbottenspets|lapphund)/i.test(n)) {
      return 'northern';
    }

    // Retriever
    if (/retriever/i.test(n)) {
      return 'retriever';
    }

    // Berghunde / sehr grosse, breite Arbeitshunde
    if (/(mountain dog|sennenhund|saint bernard|st bernard|newfoundland|neufund|leonberger|pyren|kuvasz|caucasian|central asian|tornjak|komondor|mioritic|carpathian|estrela)/i.test(n)) {
      return 'mountain';
    }

    // Hüte-/Schäferhunde
    if (/(shepherd|schäfer|collie|kelpie|cattle dog|sheepdog|beauceron|briard|mudi|puli|pumi|schapendoes|hovawart|berger picard)/i.test(n)) {
      return 'shepherd';
    }

    // Pudel-Typ
    if (/(poodle|pudel)/i.test(n)) {
      return 'poodle_slim';
    }

    // Terrier / Pinscher / Schnauzer
    if (/(terrier|schnauzer|pinscher|jagdterrier)/i.test(n)) {
      return 'terrier';
    }

    // Kleine kompakte Begleithunde
    if (/(chihuahua|pug|mops|bichon|maltese|malteser|havanese|havaneser|papillon|pekingese|shih tzu|pomeranian|zwergspitz|cavalier|boston terrier|bolognese|löwchen|lowchen|russian toy|japanese chin|griffon)/i.test(n)) {
      return 'small_compact';
    }

    // Sehr grosse, aber relativ schlanke Typen
    if (/(great dane|deutsche dogge)/i.test(n)) {
      return 'giant_slim';
    }

    return 'average';
  }

  function getBreedMorphologyKey(breed) {
    if (!breed) return 'average';

    if (BREED_MORPHOLOGY[breed]) {
      return BREED_MORPHOLOGY[breed];
    }

    const canonical = getCanonicalBreedName(breed);

    if (BREED_MORPHOLOGY[canonical]) {
      return BREED_MORPHOLOGY[canonical];
    }

    return inferBreedMorphology(canonical || breed);
  }

  function getBreedWeightReference(breed) {
    const canonical = getCanonicalBreedName(breed);
    const reference = BREED_WEIGHT_REFERENCE[canonical] || BREED_WEIGHT_REFERENCE[breed] || null;
    if (!reference) return null;

    // AKC/FCI ranges stay tied to their source. When a breed has more than one
    // source range, average the range midpoints and both endpoints.
    const sourceRanges = Array.isArray(reference.sourceRanges)
      ? reference.sourceRanges.filter(range =>
          Number.isFinite(Number(range.minKg)) &&
          Number.isFinite(Number(range.maxKg)) &&
          Number(range.maxKg) >= Number(range.minKg)
        )
      : [];
    const ranges = sourceRanges.length ? sourceRanges : [reference];
    const average = key => {
      const values = ranges.map(range => Number(range[key])).filter(Number.isFinite);
      return values.length ? values.reduce((sum,value) => sum + value,0) / values.length : null;
    };
    const minKg = sourceRanges.length ? average('minKg') : Number(reference.minKg);
    const maxKg = sourceRanges.length ? average('maxKg') : Number(reference.maxKg);
    const averageKg = ranges.reduce((sum,range) =>
      sum + ((Number(range.minKg) + Number(range.maxKg)) / 2),0) / ranges.length;
    return { ...reference, minKg, maxKg, averageKg, sourceRangeCount: ranges.length };
  }

  function getBreedWeightConfidence(weight,reference) {
    const w = Number(weight);

    if (!reference || !Number.isFinite(w) || w <= 0) {
      return 0.50;
    }

    const min = Number(reference.minKg);
    const max = Number(reference.maxKg);

    if (!Number.isFinite(min) || !Number.isFinite(max) || max <= 0) {
      return 0.50;
    }

    if (w >= min && w <= max) {
      return 1.0;
    }

    const boundary = w < min ? min : max;
    const deviationRatio = Math.abs(w - boundary) / Math.max(boundary,1);

    /*
      Ausserhalb des typischen Erwachsenenbereichs sinkt das Vertrauen in die
      Rasseform schrittweise. Das Gewicht selbst bleibt aber als reale,
      individuelle Information vollständig im Modell.
    */
    return clampNumber(1 - (deviationRatio * 1.65),0.25,0.95);
  }

  function getBackScaleWeight(weight,reference) {
    const w = Number(weight);
    if (!Number.isFinite(w) || w <= 0) return null;

    if (!reference) return w;

    const max = Number(reference.maxKg);
    if (!Number.isFinite(max) || max <= 0 || w <= max) {
      // Unter dem Erwachsenenbereich kann ein Welpe/Junghund vorliegen:
      // für die Skelettlänge deshalb bewusst das tatsächliche Gewicht nutzen.
      return w;
    }

    /*
      Oberhalb des typischen Erwachsenenbereichs darf zusätzliches Körpergewicht
      nicht 1:1 in längere Knochen/Rückenlänge übersetzt werden. Nur 25% des
      Mehrgewichts fliesst deshalb in die Längenskalierung ein.
    */
    return max + ((w - max) * 0.25);
  }

  function getDogBodyContext(profile) {
    const weight = Number(profile.weight);
    const breed = String(profile.breed || '').trim();
    const canonicalBreed = getCanonicalBreedName(breed);
    const weightReference = getBreedWeightReference(breed);

    const explicitlyKnown =
      Boolean(BREED_MORPHOLOGY[breed]) ||
      Boolean(BREED_MORPHOLOGY[canonicalBreed]) ||
      Boolean(weightReference);

    const knownBreed =
      explicitlyKnown &&
      breed !== 'Mischling / andere Rasse';

    const morphologyKey = getBreedMorphologyKey(breed);
    const morphology = BODY_MORPHOLOGY[morphologyKey] || BODY_MORPHOLOGY.average;

    if (!Number.isFinite(weight) || weight <= 0) {
      return {
        available: false,
        weight: null,
        breed,
        canonicalBreed,
        knownBreed,
        morphologyKey,
        weightReference,
        breedWeightConfidence: 0,
        contextWeight: 0,
        backScaleWeight: null,
        possibleJuvenile: false,
        genericExpected: {},
        breedExpected: {}
      };
    }

    const breedWeightConfidence = knownBreed
      ? getBreedWeightConfidence(weight,weightReference)
      : 0;

    const scale = Math.cbrt(weight);
    const backScaleWeight = getBackScaleWeight(weight,weightReference);
    const backScale = Number.isFinite(backScaleWeight) && backScaleWeight > 0
      ? Math.cbrt(backScaleWeight)
      : scale;

    const possibleJuvenile = Boolean(
      knownBreed &&
      weightReference &&
      Number.isFinite(Number(weightReference.minKg)) &&
      weight < Number(weightReference.minKg)
    );

    const genericExpected = {
      neck: HYBRID_FIT.neckExpectedFactor * scale,
      chest: HYBRID_FIT.chestExpectedFactor * scale,
      back: HYBRID_FIT.backExpectedFactor * backScale
    };

    const breedExpected = {
      neck: genericExpected.neck * morphology.neck,
      chest: genericExpected.chest * morphology.chest,
      back: genericExpected.back * Number(morphology.back || 1)
    };

    const contextWeight = knownBreed
      ? (
          HYBRID_FIT.bodyContextWeightKnownBreedMin +
          (
            HYBRID_FIT.bodyContextWeightKnownBreedMax -
            HYBRID_FIT.bodyContextWeightKnownBreedMin
          ) * breedWeightConfidence
        )
      : HYBRID_FIT.bodyContextWeightUnknownBreed;

    return {
      available: true,
      weight,
      breed,
      canonicalBreed,
      knownBreed,
      morphologyKey,
      weightReference,
      breedWeightConfidence,
      contextWeight,
      backScaleWeight,
      possibleJuvenile,
      genericExpected,
      breedExpected
    };
  }

  function clampNumber(value,min,max) {
    return Math.max(min,Math.min(max,value));
  }

  function getBodyPlausibilityThreshold(context,type) {
    if (!context.knownBreed) {
      if (type === 'neck') return HYBRID_FIT.extremeNeckConflictUnknownBreed;
      if (type === 'back') return HYBRID_FIT.extremeBackConflictUnknownBreed;
      return HYBRID_FIT.extremeChestConflictUnknownBreed;
    }

    const confidence = clampNumber(Number(context.breedWeightConfidence || 0.5),0,1);

    if (type === 'neck') {
      return (
        HYBRID_FIT.extremeNeckConflictKnownBreedMax -
        (
          HYBRID_FIT.extremeNeckConflictKnownBreedMax -
          HYBRID_FIT.extremeNeckConflictKnownBreedMin
        ) * confidence
      );
    }

    if (type === 'back') {
      let threshold = (
        HYBRID_FIT.extremeBackConflictKnownBreedMax -
        (
          HYBRID_FIT.extremeBackConflictKnownBreedMax -
          HYBRID_FIT.extremeBackConflictKnownBreedMin
        ) * confidence
      );

      /*
        Liegt das Gewicht unter dem typischen Erwachsenenbereich, kann der Hund
        noch im Wachstum sein. Die Erwartung wird bereits mit seinem aktuellen
        Gewicht skaliert; zusätzlich bleibt die Warnschwelle etwas grosszügiger.
      */
      if (context.possibleJuvenile) {
        threshold = Math.min(0.44,threshold + 0.035);
      }

      return threshold;
    }

    return (
      HYBRID_FIT.extremeChestConflictKnownBreedMax -
      (
        HYBRID_FIT.extremeChestConflictKnownBreedMax -
        HYBRID_FIT.extremeChestConflictKnownBreedMin
      ) * confidence
    );
  }

  function getBodyPlausibilityIssues(data,m,profile) {
    const context = getDogBodyContext(profile);
    if (!context.available) return [];

    const issues = [];

    for (const type of data.measures || []) {
      if (type !== 'neck' && type !== 'chest' && type !== 'back') continue;

      const value = Number(m[type]);
      const expected = Number(
        context.knownBreed
          ? context.breedExpected[type]
          : context.genericExpected[type]
      );

      if (!Number.isFinite(value) || !Number.isFinite(expected) || expected <= 0) continue;

      const deviationRatio = Math.abs(value - expected) / expected;
      const absoluteDifference = Math.abs(value - expected);
      const threshold = getBodyPlausibilityThreshold(context,type);
      const minimumCm = type === 'neck'
        ? HYBRID_FIT.minimumNeckConflictCm
        : type === 'back'
          ? HYBRID_FIT.minimumBackConflictCm
          : HYBRID_FIT.minimumChestConflictCm;

      if (deviationRatio >= threshold && absoluteDifference >= minimumCm) {
        issues.push({
          type,
          value,
          expected,
          deviationRatio,
          absoluteDifference,
          threshold,
          kind: 'dimension'
        });
      }
    }

    /*
      Verhältnis Hals/Brust als zweite Plausibilitätsprüfung.
      Nur wenn beide Werte abgefragt werden und die Rasse bekannt ist.
      Ein bereits erkannter Einzel-Ausreisser wird nicht doppelt ausgegeben.
    */
    if (
      context.knownBreed &&
      (data.measures || []).includes('neck') &&
      (data.measures || []).includes('chest')
    ) {
      const neck = Number(m.neck);
      const chest = Number(m.chest);
      const expectedNeck = Number(context.breedExpected.neck);
      const expectedChest = Number(context.breedExpected.chest);

      if (
        Number.isFinite(neck) &&
        Number.isFinite(chest) &&
        chest > 0 &&
        Number.isFinite(expectedNeck) &&
        Number.isFinite(expectedChest) &&
        expectedChest > 0
      ) {
        const measuredRatio = neck / chest;
        const expectedRatio = expectedNeck / expectedChest;
        const ratioDeviation = Math.abs(measuredRatio - expectedRatio) / expectedRatio;
        const confidence = clampNumber(Number(context.breedWeightConfidence || 0.5),0,1);

        const ratioThreshold =
          HYBRID_FIT.ratioConflictKnownBreedMax -
          (
            HYBRID_FIT.ratioConflictKnownBreedMax -
            HYBRID_FIT.ratioConflictKnownBreedMin
          ) * confidence;

        if (ratioDeviation >= ratioThreshold) {
          /*
            Ein auffälliges Hals-/Brust-Verhältnis sagt allein noch nicht,
            WELCHER der beiden Messwerte falsch ist. Deshalb markieren wir
            nicht pauschal Hals oder Brust, sondern den Wert, der relativ
            stärker von der rasse-/gewichtsbezogenen Erwartung abweicht.
            Zusätzlich muss auch hier eine sinnvolle absolute Abweichung
            vorliegen, damit kleine Hunde nicht wegen weniger Zentimeter
            unnötig zum Nachmessen aufgefordert werden.
          */
          const neckDeviation = Math.abs(neck - expectedNeck) / expectedNeck;
          const chestDeviation = Math.abs(chest - expectedChest) / expectedChest;
          const suspectType = neckDeviation >= chestDeviation ? 'neck' : 'chest';
          const suspectValue = suspectType === 'neck' ? neck : chest;
          const suspectExpected = suspectType === 'neck' ? expectedNeck : expectedChest;
          const suspectDeviation = suspectType === 'neck' ? neckDeviation : chestDeviation;
          const suspectAbsoluteDifference = Math.abs(suspectValue - suspectExpected);
          const minimumCm = suspectType === 'neck'
            ? HYBRID_FIT.minimumNeckConflictCm
            : HYBRID_FIT.minimumChestConflictCm;

          if (
            suspectAbsoluteDifference >= minimumCm &&
            !issues.some(issue => issue.type === suspectType)
          ) {
            issues.push({
              type: suspectType,
              value: suspectValue,
              expected: suspectExpected,
              deviationRatio: suspectDeviation,
              ratioDeviation,
              absoluteDifference: suspectAbsoluteDifference,
              threshold: ratioThreshold,
              kind: 'ratio'
            });
          }
        }
      }
    }

    return issues.sort((a,b) => b.deviationRatio - a.deviationRatio);
  }

  function validateMeasurements(m) {
    const limits = {
      neck: [15,90],
      chest: [25,150],
      back: [15,110],
      hip: [45,190]
    };

    for (const [key,value] of Object.entries(m)) {
      const [min,max] = limits[key];
      if (!Number.isFinite(value) || value < min || value > max) {
        return { ok:false, message:`${measureName(key)} wirkt ungewöhnlich (${value} cm). Bitte miss nochmals nach.` };
      }
    }
    return { ok:true };
  }

  function measureName(type) {
    return ({ neck:'den Halsumfang', chest:'den Brustumfang', back:'die Rückenlänge', hip:'den Hüftumfang' })[type] || 'das Mass';
  }

  window.BeitoDogPlausibility = {
    getBreedWeightReference,
    validateMeasurements,
    check(profile, requestedMeasures) {
      const context = getDogBodyContext(profile);
      const measures = (requestedMeasures || ['neck','chest','back']).filter(type => ['neck','chest','back'].includes(type) && profile[type] !== null && profile[type] !== '' && Number.isFinite(Number(profile[type])));
      const issues = getBodyPlausibilityIssues({measures},profile,profile);
      const reference = context.weightReference;
      // Adult weight is a guide. Only extreme deviations require confirmation;
      // a young dog's weight alone must never be rejected as impossible.
      const extremeWeight = Boolean(context.knownBreed && reference && (
        context.weight > Number(reference.maxKg) * 1.1 ||
        context.weight < Number(reference.minKg) * 0.75
      ));
      return { issues, extremeWeight, reference, context };
    }
  };
})();
